__turbopack_context__.v({
  "description": "breedHealthConsiderations-module-scss-module__AKMUrG__description",
  "hasTooltip": "breedHealthConsiderations-module-scss-module__AKMUrG__hasTooltip",
  "heading": "breedHealthConsiderations-module-scss-module__AKMUrG__heading",
  "healthConsiderations": "breedHealthConsiderations-module-scss-module__AKMUrG__healthConsiderations",
  "table": "breedHealthConsiderations-module-scss-module__AKMUrG__table",
  "tableContainer": "breedHealthConsiderations-module-scss-module__AKMUrG__tableContainer",
  "tableHeader": "breedHealthConsiderations-module-scss-module__AKMUrG__tableHeader",
  "title": "breedHealthConsiderations-module-scss-module__AKMUrG__title",
  "tooltip": "breedHealthConsiderations-module-scss-module__AKMUrG__tooltip",
});
